import {request} from '@/assets/js/api/_helpers'

export const ENDPOINT_MATCHING_ARCHIVES_ISSUES = '/api/requests/matching/archives/issues'


export default {
    result: ({id, ...config}) => request( 'POST', `${ENDPOINT_MATCHING_ARCHIVES_ISSUES}/${id}/result`, config),
    list: (config) => request( 'GET', ENDPOINT_MATCHING_ARCHIVES_ISSUES, config),
    viewed: ({id, ...config}) => request( 'POST', `${ENDPOINT_MATCHING_ARCHIVES_ISSUES}/${id}/viewed`, config),
}